import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { TranslateModule } from '@ngx-translate/core';
import { CREDIT_COSTS } from '../../../../config/credits';
import { LpButtonComponent } from '../lp-button/lp-button.component';

/**
 * Unlock-email confirm modal (spec §4.3 / §8.1). Presentational: emits `confirm`;
 * the host dispatches `persons.unlockEmailRequested` (409 archived → toast in effect).
 */
@Component({
  selector: 'app-unlock-email-confirm-modal',
  standalone: true,
  imports: [CommonModule, A11yModule, TranslateModule, LpButtonComponent],
  templateUrl: './unlock-email-confirm-modal.component.html',
})
export class UnlockEmailConfirmModalComponent {
  @Input() personName = '';
  readonly cost = CREDIT_COSTS.email_retrieval;

  @Output() confirm = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closed.emit();
  }
}
